import * as types from './mutation-types';

export default {
  [types.SET_SUBSCRIPTION](state, payload) {
    state.subscription = payload;
  },
  [types.SET_IS_PLAN_360](state, payload) {
    state.isPlan360 = payload;
  },
};
